<template>
  <div class="right">
    {{ params.value ? numberComma(params.value.toFixed(2)) + " %" : "-" }}
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log("params", this.params);
  },
  methods: {
    numberComma(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  padding-right: 10%;
}
</style>